module.exports = __webpack_public_path__ + "static/media/carta_93.cd74933a.jpg";